import Immutable from "seamless-immutable";
import VENDOR from "../types/Vendor";
import APP from "../types/App";

// Create initial Redux State for "user"
const INITIAL_STATE = Immutable({
  fetching: false,
  saving: false,
  instagram: {
    posts: [],
    fetching: false,
  },
});

const VendorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VENDOR.GET_INSTAGRAM_POSTS_RECEIVE:
      return state.merge({
        // TODO: In place unless we can add a limit to the endpoint
        instagram: {
          posts: action.posts.slice(0, 4),
          fetching: false,
        },
      });
    case VENDOR.GET_INSTAGRAM_POSTS_REQUEST:
      return Immutable.updateIn(state, ["instagram", "fetching"], () => true);
    case VENDOR.GET_INSTAGRAM_POSTS_FAILURE:
      return Immutable.updateIn(state, ["instagram", "fetching"], () => false);
    case APP.REHYDRATION_COMPLETE:
      // Just doing state.merge({ rehydrationComplete: true })
      // only merges persisted state with keys that are NOT blacklisted
      // To preserve 'errors', need to merge INITIAL_STATE with the
      // persisted state along with updated rehydrationComplete
      return INITIAL_STATE.merge(state);
    default:
      return state;
  }
};

export default VendorReducer;
